import {
  ApiResponse,
  AdSupplier,
  PaginationQuery,
  PaginationResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseAdSuppliersParams extends PaginationQuery {
  supplier_name?: string
  providerId?: number
  adSupplierGroupId?: number
}

export function useAdSuppliers({ page = 1, pageSize = 10, supplier_name, providerId, adSupplierGroupId }: UseAdSuppliersParams) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (supplier_name) params.supplier_name = supplier_name
  if (providerId) params.providerId = providerId
  if (adSupplierGroupId) params.ad_supplier_group_id = adSupplierGroupId

  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<AdSupplier>>>(
    token ? '/api/ad-suppliers' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    adSuppliers: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useAdSupplier(id: number | null) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<AdSupplier>>(
    token && id ? `/api/ad-suppliers/${id}` : null,
    undefined,
    token ?? '',
  )

  return {
    adSupplier: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
